import { ref } from 'vue'
import type { ApiResponse } from '~/types/api'
import { useApi } from './useApi'

export type AnneeUniversitaireItem = {
	annee_universitaire: string
	label: string
	sessions_count: number
	sessions_courantes_count: number
	sessions_historiques_count: number
	est_courante: boolean
	contient_sessions_actives: boolean
	archivable: boolean
}

export type AnneesUniversitairesData = {
	annee_courante: string
	annees: AnneeUniversitaireItem[]
}

const cache = ref<AnneesUniversitairesData | null>(null)
const loading = ref(false)
const error = ref<string | null>(null)

export function useSessionAnnees() {
	const { apiData } = useApi()

	async function fetchAnnees(force = false): Promise<AnneesUniversitairesData | null> {
		if (cache.value && !force) return cache.value
		loading.value = true
		error.value = null
		try {
			const response = await apiData<ApiResponse<AnneesUniversitairesData>>(
				'/sessions/annees-universitaires'
			)
			if (response?.success && response.data) {
				cache.value = response.data
				return cache.value
			}
			error.value = response?.message || 'Impossible de charger les années universitaires'
			return null
		} catch (e: any) {
			error.value = e?.message || 'Erreur lors du chargement des années'
			return null
		} finally {
			loading.value = false
		}
	}

	function clearCache() {
		cache.value = null
	}

	return {
		anneesData: cache,
		loading,
		error,
		fetchAnnees,
		clearCache,
	}
}
